<!-- Формула ФАКТа показывает каждое итоговое число один раз и не выполняет расчёты на клиенте. -->
<template>
  <section class="fact-formula" aria-label="Формула фактического результата">
    <div class="fact-formula__tile">
      <small>Стоимость заказа</small>
      <strong>{{ formatRub(orderPrice) }}</strong>
    </div>
    <span class="fact-formula__operator" aria-hidden="true">−</span>
    <div class="fact-formula__tile">
      <small>Расходы · {{ expenseCountLabel }}</small>
      <strong>{{ formatRub(expensesTotal) }}</strong>
    </div>
    <span class="fact-formula__operator" aria-hidden="true">=</span>
    <div
      class="fact-formula__tile fact-formula__tile--profit"
      :class="{ 'fact-formula__tile--loss': numericProfit < 0 }"
    >
      <small>Прибыль</small>
      <strong>{{ formatRub(profit) }}</strong>
    </div>
    <span class="fact-formula__operator" aria-hidden="true">÷</span>
    <div
      class="fact-formula__tile"
      :class="{ 'fact-formula__tile--manual': overridden || !hasMileage }"
    >
      <small>Пробег · {{ mileageSource }}</small>
      <strong>{{ formatMileage(mileage) }}</strong>
    </div>
    <span class="fact-formula__operator" aria-hidden="true">=</span>
    <div class="fact-formula__tile">
      <small>
        На км
        <template v-if="hasValue(plannedProfitPerKm)">
          · план {{ formatNumber(plannedProfitPerKm) }}
        </template>
      </small>
      <strong>{{ formatPerKm(profitPerKm) }}</strong>
    </div>
  </section>
</template>

<script>
import { formatBigNumber } from "@/utils/numberUtils";

export default {
  name: "OrderPlanCalculationFactFormula",

  props: {
    orderPrice: { type: [String, Number], default: null },
    expensesTotal: { type: [String, Number], default: null },
    expenseCountLabel: { type: String, default: "0 записей" },
    profit: { type: [String, Number], default: null },
    mileage: { type: [String, Number], default: null },
    overridden: { type: Boolean, default: false },
    profitPerKm: { type: [String, Number], default: null },
    plannedProfitPerKm: { type: [String, Number], default: null },
  },

  computed: {
    hasMileage() {
      return this.hasValue(this.mileage);
    },
    mileageSource() {
      if (this.overridden) return "вручную";
      return this.hasMileage ? "телеметрия" : "нет данных";
    },
    numericProfit() {
      return Number(this.profit || 0);
    },
  },

  methods: {
    formatNumber(value) {
      return this.hasValue(value) ? formatBigNumber(value) : "—";
    },
    formatRub(value) {
      return this.hasValue(value) ? `${formatBigNumber(value)} ₽` : "—";
    },
    formatMileage(value) {
      return this.hasValue(value) ? `${formatBigNumber(value)} км` : "—";
    },
    formatPerKm(value) {
      return this.hasValue(value) ? `${formatBigNumber(value)} ₽` : "—";
    },
    hasValue(value) {
      return value !== null && value !== undefined && value !== "";
    },
  },
};
</script>

<style scoped>
.fact-formula {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 14px minmax(0, 1.1fr) 14px minmax(0, 1.05fr) 14px minmax(0, 1.15fr) 14px minmax(0, 1fr);
  align-items: stretch;
  gap: 6px;
  padding: 12px;
  border: 1px solid #ffedd5;
  border-radius: 10px;
}

.fact-formula__tile {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #f8f9fb;
}

.fact-formula__tile small {
  overflow: hidden;
  color: #5b6070;
  font-size: 11px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fact-formula__tile strong {
  overflow: hidden;
  font-size: 15px;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fact-formula__tile--profit {
  background: #ecfdf3;
  color: #15803d;
}

.fact-formula__tile--profit small {
  color: #15803d;
}

.fact-formula__tile--loss {
  background: #fef2f2;
  color: #b91c1c;
}

.fact-formula__tile--loss small {
  color: #b91c1c;
}

.fact-formula__tile--manual {
  border-color: #fde68a;
  background: #fffbeb;
  color: #854d0e;
}

.fact-formula__operator {
  align-self: center;
  color: #8b93a7;
  text-align: center;
}

@media (max-width: 560px) {
  .fact-formula {
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
    padding: 8px;
  }

  .fact-formula__operator {
    display: none;
  }
}
</style>
